import ActionTypes from "../constants/action_types";

export default function clear() {
  return {
    type: ActionTypes.ANALYTICS_CLEAR.SUCCESS,
  };
}
